module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-593.06a8c91.woff2";